/**
 * Rail de vignettes desktop (page produit).
 * - Mesure la hauteur réelle du rail et l'expose en --thumb-rail-h : le CSS
 *   centre le sticky sur le viewport (top: calc(50vh - h/2)). Re-mesuré au
 *   chargement des images / resize via ResizeObserver.
 * - Clic sur une vignette : défilement doux (style ancre) jusqu'au visuel
 *   secondaire correspondant, centré dans le viewport.
 */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.product-thumb-rail').forEach(function (rail) {
      var setHeight = function () {
        rail.style.setProperty('--thumb-rail-h', rail.offsetHeight + 'px');
      };
      setHeight();

      if ('ResizeObserver' in window) {
        new ResizeObserver(setHeight).observe(rail);
      } else {
        window.addEventListener('resize', setHeight);
      }

      rail.addEventListener('click', function (event) {
        var link = event.target.closest('a[href*="#"]');
        if (!link) return;
        var target = document.getElementById(link.getAttribute('href').split('#')[1]);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
